import { render, staticRenderFns } from "./PassengerForm.vue?vue&type=template&id=68244b62&scoped=true&"
import script from "./PassengerForm.vue?vue&type=script&lang=js&"
export * from "./PassengerForm.vue?vue&type=script&lang=js&"
import style0 from "./PassengerForm.vue?vue&type=style&index=0&id=68244b62&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68244b62",
  null
  
)

export default component.exports